<template>
	<img
		v-if="flagDataUri"
		:src="flagDataUri"
		:style="{ width: `${displaySize.width}px`, height: `${displaySize.height}px` }"
		alt=""
	/>
</template>

<script setup lang="ts">
import { computed } from "vue"
import {
	buildOpportunityIconDataUri,
	iconDisplaySize,
	resolveBadges,
	resolveIconFamily,
} from "@/utils/opportunityIcons"

const props = defineProps({
	type: {
		type: String,
	},
	salesProcessStatus: {
		type: String,
		undefined: true,
	},
	launchDateMs: {
		type: Number,
		undefined: true,
	},
	isPlaceholder: {
		type: Boolean,
		undefined: true,
	},
})

// matches --size-icon-xl
const CIRCLE_DIAMETER = 24

const badges = computed(() =>
	resolveBadges({
		salesProcessStatus: props.salesProcessStatus,
		launchDateMs: props.launchDateMs,
		isPlaceholder: props.isPlaceholder,
	})
)

const displaySize = computed(() => iconDisplaySize(badges.value, CIRCLE_DIAMETER))

const flagDataUri = computed(() => {
	const resolvedFamily = resolveIconFamily(props.type)
	if (!resolvedFamily) return null
	return buildOpportunityIconDataUri(resolvedFamily.color, badges.value)
})
</script>
